import Icon from "@ant-design/icons";

export const Component = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.94667 3.74939C7.91494 3.66756 7.86736 3.5928 7.80667 3.52939L4.47333 0.196061C4.41117 0.133902 4.33738 0.084595 4.25617 0.0509548C4.17495 0.0173146 4.08791 0 4 0C3.82247 0 3.6522 0.0705253 3.52667 0.196061C3.46451 0.25822 3.4152 0.332014 3.38156 0.413228C3.34792 0.494443 3.33061 0.581488 3.33061 0.669394C3.33061 0.846929 3.40113 1.01719 3.52667 1.14273L5.72667 3.33606L0.666667 3.33606C0.489856 3.33606 0.320287 3.4063 0.195262 3.53132C0.070238 3.65635 0 3.82592 0 4.00273C0 4.17954 0.070238 4.34911 0.195262 4.47413C0.320287 4.59916 0.489856 4.66939 0.666667 4.66939L5.72667 4.66939L3.52667 6.86273C3.46418 6.9247 3.41459 6.99844 3.38074 7.07968C3.34689 7.16092 3.32947 7.24805 3.32947 7.33606C3.32947 7.42407 3.34689 7.51121 3.38074 7.59244C3.41459 7.67368 3.46418 7.74742 3.52667 7.80939C3.58864 7.87188 3.66238 7.92148 3.74362 7.95532C3.82486 7.98917 3.91199 8.00659 4 8.00659C4.08801 8.00659 4.17515 7.98917 4.25638 7.95532C4.33762 7.92148 4.41136 7.87188 4.47333 7.80939L7.80667 4.47606C7.86736 4.41266 7.91494 4.3379 7.94667 4.25606C8.01335 4.09375 8.01335 3.9117 7.94667 3.74939Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowRightIcon = (props) => (
  <Icon component={Component} {...props} />
);
